var $e6b6e66aee4d7622$exports = {};
$e6b6e66aee4d7622$exports = {
    "valid": `\u{6709}\u{6548}`
};


export {$e6b6e66aee4d7622$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
